import { layers } from '@jira/platform__ui-layers';

type CSSProperties = Partial<CSSStyleDeclaration>;
export const customStyles = {
	menu: (base: CSSProperties) => ({
		...base,
		zIndex: layers.modal,
	}),
	menuPortal: (base: CSSProperties) => ({
		...base,
		zIndex: layers.modal,
	}),
} as const;
